import { useDispatch, useSelector } from 'react-redux';
import { setMyData } from '../store';
import './css/app.css'
import './css/main.css'
import './css/common.css'
import './css/payment.css'
import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, CountAmountLeft } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import html2canvas from 'html2canvas';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchCrteateBtn } from './component/search/search';
import dayjs from 'dayjs';
import { formatDateTime, changeNum, getImageSrc } from './common/function';
import { Copy } from 'lucide-react';

import useWindowSize from './hook/useWindowSize'

function UrlCreate() {
    let navigate = useNavigate();
    let dispatch = useDispatch()

    const { Rwidth, Rheight } = useWindowSize();
    const MyData = useSelector((state) => state.MyData);

    const [loading, setLoading] = useState(true)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(0)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [amount, setAmount] = useState([1000000, 50000])
    const [modal1, setModal1] = useState(false)

    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [reload, setReload] = useState(false)


    const [createModal, setCreateModal] = useState(false);
    const [updateModal, setUpdataeModal] = useState(false);
    const [clickData, setClickData] = useState(null);
    const [message, setMessage] = useState("");

    useEffect(() => {
        dispatch(change_Current_Location("URL상품관리"))
        dispatch(changeHeaderTitle({
            mainTitle: "URL상품관리",
            subTitle: ""
        }))
        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    // 기간 포맷
    const inputRef = useRef(null);   // 숨겨진(또는 실제) datepicker input
    const pickerRef = useRef(null);  // Litepicker instance

    // 날짜 상태 (초기값: 이번 달)
    const [preDate, setPreDate] = useState(dayjs().startOf('month').format('YYYY/MM/DD'));
    const [nextDate, setNextDate] = useState(dayjs().endOf('month').format('YYYY/MM/DD'));

    // ★ 핵심: inputRef.current(또는 화면폭) 바뀔 때마다 재부착
    useEffect(() => {
        const el = inputRef.current;
        if (!el) return;

        // 기존 인스턴스 정리
        if (pickerRef.current) {
            pickerRef.current.destroy();
            pickerRef.current = null;
        }

        // 새 인스턴스 부착
        const picker = new Litepicker({
            element: el,
            lang: "ko",
            singleMode: false,
            format: "YYYY/MM/DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: { minYear: 2020, maxYear: 2030, months: true, years: true },
            setup: (p) => {
                p.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY/MM/DD"));
                    setNextDate(end.format("YYYY/MM/DD"));
                });
            },
        });

        pickerRef.current = picker;

        // 현재 선택 범위 반영
        picker.setDateRange(preDate, nextDate);

        // cleanup
        return () => {
            picker.destroy();
            pickerRef.current = null;
        };
        // 화면 레이아웃 전환시에도 재초기화를 원하면 Rwidth 같은 뷰포트 상태도 deps에 포함
    }, [inputRef.current /*, Rwidth */]);

    // 날짜 상태가 바뀌면 picker에도 반영 (인스턴스가 살아있을 때만)
    useEffect(() => {
        pickerRef.current?.setDateRange(preDate, nextDate);
    }, [preDate, nextDate]);

    // 공용 setter
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        setPage(1);
    };

    useEffect(() => {
        ListData()
    }, [reload, page])

    const ListData = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/url-products", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setListData(tmp?.data?.products ?? [])
                // setAmount([Number(tmp?.data?.summary?.total_amount), Number(tmp?.data?.summary?.cancel_amount)])
                setTotalPage(tmp?.data?.pagination?.total ?? 0)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = [
        { "no": 1, "text": "URL", "width": "300px", "textAlign": "center" },
        { "no": 2, "text": "상품코드", "width": "70px", "textAlign": "center" },
        { "no": 3, "text": "상품명", "width": "100px", "textAlign": "center" },
        { "no": 4, "text": "결제금액", "width": "70px", "textAlign": "center" },
        { "no": 5, "text": "상태", "width": "60px", "textAlign": "center" },
    ];

    const handleCopy = (product_url) => {
        if (product_url) {
            navigator.clipboard
                .writeText(product_url)
                .then(() => {
                    alert("URL이 복사되었습니다.");
                })
                .catch((err) => {
                    console.error("클립보드 복사 실패:", err);
                });
        }
    };

    // SMS 전송 함수
    const handleSmsSend = async (product_url, smsType, phoneNumber) => {
        try {
            // URL에 type 파라미터 추가
            const urlWithType = smsType === 'KYC' 
                ? `${product_url}${product_url.includes('?') ? '&' : '?'}type=a`
                : `${product_url}${product_url.includes('?') ? '&' : '?'}type=b`;

            // SMS 메시지 내용 생성
            const messageContent = smsType === 'KYC' 
                ? `수기결제 링크: ${urlWithType}` 
                : `인증결제 링크: ${urlWithType}`;

            const response = await axios.post(`${process.env.REACT_APP_API}/api/sms/send`, {
                messageType: "SMS",
                callback: process.env.REACT_APP_SMS_CALLBACK_NUMBER || "0319908587",
                phoneList: [
                    { phone: phoneNumber.replace(/[^0-9]/g, '') } // 숫자만 추출
                ],
                carrierMessage: {
                    message: messageContent
                }
            });
            
            if (response.status === 200) {
                alert("SMS가 전송되었습니다.");
            } else {
                alert("SMS 전송에 실패했습니다.");
            }
        } catch (error) {
            console.error("SMS 전송 오류:", error);
            alert("SMS 전송 중 오류가 발생했습니다.");
        }
    };

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            let list = listData ?? []

            for (let i = 0; i < list.length; i++) {
                let data = list[i];

                let rowData = [
                    {
                        "no": 1, "text": (
                            <div className="flex flex-col items-center" style={{ gap: "5px" }}>
                            <div
                                className="flex justify-center items-center"
                                style={{ gap: "5px", cursor: "pointer" }}
                                onClick={() => handleCopy(data.product_url)}
                            >
                                <div className='table-overflow-hidden' style={{ width: "calc(100% - 15px)", overflow: "hidden" }}>
                                    {data.product_url}
                                </div>
                                <div style={{ width: "15px" }}>
                                    <Copy size={15} />
                                    </div>
                                </div>
                                <div className="flex gap-2">
                                    {MyData.smsKYC === 1 && (
                                        <button
                                            onClick={() => handleSmsSend(data.product_url, 'KYC')}
                                            style={{ 
                                                fontSize: "10px", 
                                                padding: "4px 8px",
                                                backgroundColor: "#3b82f6",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "6px",
                                                cursor: "pointer",
                                                fontWeight: "500",
                                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                transition: "all 0.2s ease",
                                                minWidth: "60px"
                                            }}
                                            onMouseOver={(e) => {
                                                e.target.style.backgroundColor = "#2563eb";
                                                e.target.style.transform = "translateY(-1px)";
                                                e.target.style.boxShadow = "0 2px 6px rgba(0,0,0,0.15)";
                                            }}
                                            onMouseOut={(e) => {
                                                e.target.style.backgroundColor = "#3b82f6";
                                                e.target.style.transform = "translateY(0)";
                                                e.target.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
                                            }}
                                        >
                                            수기결제
                                        </button>
                                    )}
                                    {MyData.smsConfirm === 1 && (
                                        <button
                                            onClick={() => handleSmsSend(data.product_url, 'CONFIRM')}
                                            style={{ 
                                                fontSize: "10px", 
                                                padding: "4px 8px",
                                                backgroundColor: "#10b981",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "6px",
                                                cursor: "pointer",
                                                fontWeight: "500",
                                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                transition: "all 0.2s ease",
                                                minWidth: "60px"
                                            }}
                                            onMouseOver={(e) => {
                                                e.target.style.backgroundColor = "#059669";
                                                e.target.style.transform = "translateY(-1px)";
                                                e.target.style.boxShadow = "0 2px 6px rgba(0,0,0,0.15)";
                                            }}
                                            onMouseOut={(e) => {
                                                e.target.style.backgroundColor = "#10b981";
                                                e.target.style.transform = "translateY(0)";
                                                e.target.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
                                            }}
                                        >
                                            인증결제
                                        </button>
                                    )}
                                </div>
                            </div>
                        ), "width": "300px", "textAlign": "center"
                    },
                    { "no": 2, "text": data.product_code, "width": "70px", "textAlign": "center" },
                    { "no": 3, "text": data.product_name, "width": "100px", "textAlign": "center" },
                    { "no": 4, "text": changeNum(Number(data.price)), "width": "70px", "textAlign": "right" },
                    { "no": 5, "text": data.product_type == "1" ? "활성" : "비활성", "width": "60px", "textAlign": "center" },
                ]

                rowData.id = data.id ?? data.product_code;
                rowData.product_code = data.product_code;
                tableBodyData.push(rowData);
            }
            setCombineData(tableBodyData)
        }
    }, [listData, reload]);

    let tabList = ["상품 수정"]

    const [activeTab, setActiveTab] = useState("상품 수정")

    const handleClickTab = (tabName) => {
        setActiveTab(tabName);
    };

    const handleRowClick = (row) => {
        const rowId = row.id ?? row.product_code;
        const found = listData.find((d) => String(d.id ?? d.product_code) === String(rowId));
        if (found) {
            setClickData(found);
            setActiveTab("상품 수정");
            setCreateModal(false)
            setUpdataeModal(true)
        }
    }

    // ======== 모바일 전용 상태(탭 & 선택상품) + 새로고침 복원 ========
    const [mobileTab, setMobileTab] = useState(() => {
        const v = sessionStorage.getItem("urlcreate_mobileTab");
        return v ? Number(v) : 0; // 0: 관리, 1: 등록, 2: 수정
    });
    const [mobileSelected, setMobileSelected] = useState(() => {
        const v = sessionStorage.getItem("urlcreate_mobileSelected");
        try { return v ? JSON.parse(v) : null; } catch { return null; }
    });

    useEffect(() => {
        sessionStorage.setItem("urlcreate_mobileTab", String(mobileTab));
    }, [mobileTab]);

    useEffect(() => {
        if (mobileSelected) {
            sessionStorage.setItem("urlcreate_mobileSelected", JSON.stringify(mobileSelected));
        } else {
            sessionStorage.removeItem("urlcreate_mobileSelected");
        }
    }, [mobileSelected]);

    return (
        <>
            {loading ? <LoadingModal /> : ""}
            {
                Rwidth > 767
                    ?
                    <div class="content" id="contents">
                        {loading ? <LoadingModal /> : ""}
                        <MessageModal message={message} />
                        <div class="paylist">
                            <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
                                <div class="form_filter w-full">
                                    <SearchDate
                                        type={"날짜"}
                                        inputRef={inputRef}
                                        setDateRange={setDateRange}
                                        preDate={preDate}
                                        nextDate={nextDate}
                                        isDisabled={true}
                                    />
                                </div>
                            </form>
                            <div className="intro-y box intro-padding" style={{ display: "block", height: "calc(-10rem + 100dvh)" }}>
                                {/* <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end' }}>
                        <TotalAmount confirm_amt={amount[0]} canceled_amt={Number(amount[1]) * -1} />
                        <CountAmount tableBodyData={totalPage ?? 0} />
                    </div> */}

                                <div className="div-flex-2">
                                    <div style={{ maxWidth: "660px", width: "100%" }}>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div
                                                className="tabulator_sorting_wrap"
                                                style={{
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                }}
                                            >
                                                <CountAmountLeft tableBodyData={totalPage ?? []} />
                                                <div class="button_wrap separate" style={{ marginTop: "0px" }}>
                                                    <SearchCrteateBtn type={"신규 등록"}
                                                        onClick={() => {
                                                            setUpdataeModal(false);
                                                            setCreateModal(true);
                                                            setClickData(null);
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                        <List
                                            tableHeaderData={tableHeaderData}
                                            tableBodyData={totalPage ?? 0}
                                            filter_tableBodyData={combineData}
                                            page={page}
                                            setPage={setPage}
                                            maxFirstPage={maxFirstPage}
                                            clickData={clickData}
                                            onRowClick={handleRowClick}
                                            nonePage={false}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            maxWidth: createModal ? "450px" : "450px",
                                            width: "100%",
                                            marginTop: "48px"
                                        }}
                                    >
                                        {
                                            !createModal && !updateModal && !clickData && (
                                                <div style={{ width: "100%", height: "800px", border: "16px solid rgb(69 69 69)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", fontWeight: "bold", color: "gray" }}>
                                                    상품을 선택해주세요.
                                                </div>
                                            )
                                        }
                                        {createModal && (
                                            <div
                                                style={{
                                                    backgroundColor: "#575757",
                                                    padding: "16px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: "10px",
                                                        alignItems: "center",
                                                        padding: "0 10px",
                                                        borderBottom: "1px solid #E5E5E5",
                                                        backgroundColor: "#fff",
                                                    }}
                                                >
                                                    {["상품 등록"].map((tab) => (
                                                        <button
                                                            key={tab}
                                                            className="tab-btn active"
                                                            style={{
                                                                padding: "12px 10px 8px",
                                                                fontSize: "14px",
                                                                fontWeight: "600",
                                                                color: "#222",
                                                                background: "transparent",
                                                                border: "none",
                                                                borderBottom: "3px solid #3182F6",
                                                                transition: "all 0.2s ease-in-out",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            {tab}
                                                        </button>
                                                    ))}
                                                </div>
                                                <div style={{ backgroundColor: "#fff", maxHeight: "730px", overflow: "scroll" }}>
                                                    <MobileCreateInfo setMessage={setMessage} setReload={setReload} state={0} />
                                                </div>
                                            </div>
                                        )}
                                        {updateModal && clickData && (
                                            <div
                                                style={{
                                                    backgroundColor: clickData?.id ? "rgb(69 69 69)" : "",
                                                    padding: "16px",
                                                    display: "flex",
                                                }}
                                            >
                                                <div style={{
                                                    width: "100%"
                                                }}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            gap: "10px",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            padding: "0 10px",
                                                            borderBottom: "1px solid #E5E5E5",
                                                            backgroundColor: "#fff",
                                                        }}
                                                    >
                                                        <div style={{ display: "flex", gap: "10px" }}>
                                                            {tabList.map((tab) => (
                                                                <button
                                                                    key={tab}
                                                                    className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                                                    onClick={() => handleClickTab(tab)}
                                                                    style={{
                                                                        padding: "12px 10px 8px",
                                                                        fontSize: "14px",
                                                                        fontWeight: activeTab === tab ? "600" : "400",
                                                                        color: activeTab === tab ? "#222" : "#888",
                                                                        background: "transparent",
                                                                        border: "none",
                                                                        borderBottom: activeTab === tab ? "3px solid #3182F6" : "3px solid transparent",
                                                                        transition: "all 0.2s ease-in-out",
                                                                        cursor: "pointer"
                                                                    }}
                                                                >
                                                                    {tab}
                                                                </button>
                                                            ))}
                                                        </div>
                                                        <div
                                                            className="button_wrap separate"
                                                            style={{ marginTop: "0px" }}
                                                        >
                                                            <SearchCrteateBtn
                                                                type={"신규등록"}
                                                                onClick={() => {
                                                                    setUpdataeModal(false);
                                                                    setCreateModal(true);
                                                                    setClickData(null);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{ backgroundColor: "#fff", maxHeight: "730px", overflow: "scroll" }}>
                                                        {(activeTab === "상품 수정") && (
                                                            <MobileUpdateInfo
                                                                setMessage={setMessage}
                                                                product={clickData}
                                                                setReload={setReload}
                                                                state={0}
                                                                onBack={() => {}}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div style={{ marginTop: "58px", background: "#fff", minHeight: "calc(100dvh - 58px)" }}>
                        {mobileTab !== 2 && (
                            <div className="flex border-b" style={{
                                position: "fixed",
                                top: "58px",
                                left: "0",
                                width: "100%",
                                background: "#fff",
                                zIndex: "10",
                            }}>
                                <button className={`flex-1 py-4 text-center ${mobileTab == 0 ? "border-b-2 font-semibold border-gray-900" : "text-gray-400"}`} onClick={() => setMobileTab(0)}>상품관리</button>
                                <button className={`flex-1 py-4 text-center ${mobileTab == 1 ? "border-b-2 font-semibold border-gray-900" : "text-gray-400"}`} onClick={() => setMobileTab(1)}>상품등록</button>
                            </div>
                        )}
                        {
                            mobileTab == 0
                                ?
                                <MobileManagement
                                    products={listData}
                                    onSelectProduct={(p) => {
                                        setMobileSelected(p);
                                        setMobileTab(2);
                                    }}
                                />
                                :
                                mobileTab == 1
                                    ?
                                    <MobileCreateInfo setMessage={setMessage} setReload={setReload} setMobileTab={setMobileTab} state={1} />
                                    :
                                    <MobileUpdateInfo
                                        setMessage={setMessage}
                                        setReload={setReload}
                                        setMobileTab={setMobileTab}
                                        product={mobileSelected}
                                        onBack={() => {
                                            setMobileSelected(null);
                                            setMobileTab(0);   // 상품관리로
                                        }}
                                        state={1}
                                    />
                        }
                    </div>
            }
        </>
    )
}

function MobileManagement({ products = [], onSelectProduct }) {

    const fmt = (n) => n.toLocaleString("ko-KR");

    return (
        <div className="mobile-management-wrap">
            <h2 className="mobile-management-heading">상품관리</h2>

            <div className="mobile-management-grid">
                {products.length > 0 ? (
                    products.map((p) => (
                    <article
                        className="mobile-management-card"
                        key={p.id}
                        onClick={() => onSelectProduct && onSelectProduct(p)}
                    >
                        <div className="mobile-management-thumb">
                                <img 
                                    src={getImageSrc(p.main_image) || "https://via.placeholder.com/300x300?text=No+Image"} 
                                    alt={p.product_name} 
                                />
                        </div>

                            <h3 className="mobile-management-title">{p.product_name}</h3>

                        <div className="mobile-management-price-row">
                                <span className="mobile-management-price">{fmt(Number(p.price))}원</span>
                                {p.discount_price && Number(p.discount_price) > 0 && (
                                    <span className="mobile-management-discount">
                                        할인가: {fmt(Number(p.discount_price))}원
                                    </span>
                                )}
                        </div>


                    </article>
                    ))
                ) : (
                    <div style={{ 
                        gridColumn: "1 / -1", 
                        textAlign: "center", 
                        padding: "40px 20px",
                        color: "#666"
                    }}>
                        등록된 상품이 없습니다.
                    </div>
                )}
            </div>
        </div>
    );
}

function MobileCreateInfo({ setMessage, setReload, setMobileTab, state }) {
    // --- 초기값 팩토리 ---
    const getInitialForm = () => ({
        status: "",
        name: "",
        price: "",
        discountPrice: "",
        shippingFee: "",
        freeShippingMin: "",
        stockQty: "",
        maxQty: "",
    });
    const createBaseOption = () => ({ id: 1, name: "기본", extraPrice: "", stock: "", isBase: true });

    // 1) 폼 상태
    const [form, setForm] = useState(getInitialForm);
    const onChange = (key) => (e) => setForm((prev) => ({ ...prev, [key]: e.target.value }));

    // 2) 대표 이미지(단일)
    const repFileRef = useRef(null);
    const [repImage, setRepImage] = useState/** @type {File|null} */(null);
    const [repPreview, setRepPreview] = useState/** @type {string|null} */(null);

    const onPickRep = () => repFileRef.current?.click();
    const onRepChange = (e) => {
        const f = e.target.files?.[0];
        if (!f) return;
        if (repPreview?.startsWith("blob:")) URL.revokeObjectURL(repPreview);
        setRepImage(f);
        setRepPreview(URL.createObjectURL(f));
        e.target.value = "";
    };
    const clearRep = () => {
        if (repPreview?.startsWith("blob:")) URL.revokeObjectURL(repPreview);
        setRepImage(null);
        setRepPreview(null);
        if (repFileRef.current) repFileRef.current.value = "";
    };

    // 3) 상품설명 이미지(다중, 최대 9)
    const descFileRef = useRef(null);
    const [descImages, setDescImages] = useState/** @type {File[]} */([]);
    const [descPreviews, setDescPreviews] = useState/** @type {string[]} */([]);

    const onPickDesc = () => descFileRef.current?.click();
    const onDescChange = (e) => {
        const files = Array.from(e.target.files || []);
        if (!files.length) return;
        const room = Math.max(0, 9 - descImages.length);
        const add = files.slice(0, room);
        setDescImages((prev) => [...prev, ...add]);
        setDescPreviews((prev) => [...prev, ...add.map((f) => URL.createObjectURL(f))]);
        e.target.value = "";
    };
    const removeDescAt = (idx) => {
        setDescImages((prev) => prev.filter((_, i) => i !== idx));
        const url = descPreviews[idx];
        if (url?.startsWith("blob:")) URL.revokeObjectURL(url);
        setDescPreviews((prev) => prev.filter((_, i) => i !== idx));
    };

    /* ===== 옵션 추가 UI ===== */
    const [options, setOptions] = useState([createBaseOption()]);

    const addOption = () =>
        setOptions((prev) => [
            ...prev,
            { id: Date.now(), name: "", extraPrice: "", stock: "", isBase: false },
        ]);

    const removeOption = (id) => setOptions((prev) => prev.filter((opt) => opt.id !== id));

    const updateOption = (id, key) => (e) =>
        setOptions((prev) => prev.map((opt) => (opt.id === id ? { ...opt, [key]: e.target.value } : opt)));

    // 저장

    // 중복 클릭 방지
    const [isSubmitting, setIsSubmitting] = useState(false);

    // 숫자 문자열(쉼표 포함) → 정수
    const toInt = (v) => {
        if (v === null || v === undefined) return 0;
        const n = parseInt(String(v).replace(/[^\d-]/g, ''), 10);
        return Number.isNaN(n) ? 0 : n;
    };

    const onSubmit = async () => {
        if (isSubmitting) return;

        // 간단 검증
        if (!form.name || !form.price) {
            setMessage({ msg: "상품명과 가격을 입력하세요." });
            return;
        }

        setIsSubmitting(true);

        // 값 정리
        const price = toInt(form.price);
        const discountPrice = toInt(form.discountPrice);
        const shippingFee = toInt(form.shippingFee);
        const freeShippingMinAmount = toInt(form.freeShippingMin);
        const quantity = toInt(form.stockQty);
        const maxQty = toInt(form.maxQty);

        const isDiscountActive = discountPrice > 0 && discountPrice < price;
        const isFreeShipping = shippingFee === 0 || freeShippingMinAmount > 0;

        const fd = new FormData();
        // ✅ 서버 바디 키에 맞춰 매핑
        fd.append("productName", form.name);
        fd.append("price", String(price));
        fd.append("quantity", String(quantity));
        fd.append("productType", "1");               // 필요 시 서버 기대값에 맞춰 변경
        fd.append("discountPrice", String(discountPrice));
        fd.append("freeShippingMinAmount", String(freeShippingMinAmount));
        fd.append("shippingFee", String(shippingFee));
        fd.append("productDescription", "");               // 입력 필드가 없으므로 공란
        fd.append("isDiscountActive", String(isDiscountActive));
        fd.append("isFreeShipping", String(isFreeShipping));
        fd.append("maxQty", String(maxQty));
        // fd.append("status", form.status || "ON");

        // 대표 이미지(단일)
        if (repImage) {
            fd.append("mainImage", repImage, repImage.name);
        }

        // 옵션 JSON (서버 필드명: optionName, additionalPrice, stockQuantity, isBase)
        fd.append(
            "options",
            JSON.stringify(
                options.map(({ id, name, extraPrice, stock, isBase }) => ({
                    optionName: (name || "").trim(),
                    additionalPrice: toInt(extraPrice),
                    stockQuantity: toInt(stock),
                    isBase: !!isBase,
                }))
            )
        );

        // 설명 이미지(다중) - Multer 필드명 descriptionImages
        descImages.forEach((f) => fd.append("descriptionImages", f, f.name));

        try {
            const { data } = await axios.post(
                process.env.REACT_APP_API + "/api/url-products",
                fd,
                { withCredentials: true }
            );

            const code = data?.code ?? 0;
            if (code < 2000) {
                setMessage({ msg: "상품 등록에 성공했습니다." });
                setReload((x) => !x);

                // ✅ 성공 시 취소와 동일하게 전체 초기화
                onCancel();

                if (state === 1) setMobileTab(0);
            } else {
                setMessage({ msg: data?.msg ?? "상품 등록에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "상품 등록에 실패했습니다." });
        } finally {
            setIsSubmitting(false);
        }
    };


    // 취소: 모든 정보 초기화
    const onCancel = () => {
        // Blob URL 정리
        if (repPreview?.startsWith("blob:")) URL.revokeObjectURL(repPreview);
        descPreviews.forEach((u) => u?.startsWith("blob:") && URL.revokeObjectURL(u));

        // 값 초기화
        setForm(getInitialForm());
        setRepImage(null);
        setRepPreview(null);
        setDescImages([]);
        setDescPreviews([]);
        setOptions([createBaseOption()]);

        // 파일 인풋도 초기화
        if (repFileRef.current) repFileRef.current.value = "";
        if (descFileRef.current) descFileRef.current.value = "";
    };

    // 공용 스타일(옵션 그리드)
    const optGridStyle = {
        display: "grid",
        gridTemplateColumns: "1.7fr 1fr 1fr 40px",
        gap: "8px",
        alignItems: "center",
    };

    return (
        <div className="mobile-url-create-wrap">
            <div style={{ padding: state === 1 ? "70px 16px 0px" : "12px 16px 0px" }}>
                {/* 제목 */}
                {state === 1 && <div className="mobile-url-create-title">상품등록</div>}

                {/* 이미지 첨부 */}
                <div className="mobile-url-create-section">
                    <div className="mobile-url-create-sublabel">대표이미지 (1개)</div>
                    <div className="mobile-url-create-image-row">
                        <div className="mobile-url-create-image-box mobile-url-create-image-box-rep">
                            {repPreview ? (
                                <>
                                    <img src={getImageSrc(repPreview)} alt="대표 미리보기" />
                                    <button type="button" className="mobile-url-create-thumb-remove" onClick={clearRep}>
                                        ×
                                    </button>
                                </>
                            ) : (
                                <span />
                            )}
                        </div>
                        <button type="button" className="mobile-url-create-image-picker" onClick={onPickRep}>
                            <span className="mobile-url-create-plus" />
                            <span>이미지 선택</span>
                        </button>
                        <input ref={repFileRef} type="file" accept="image/*" onChange={onRepChange} hidden />
                    </div>
                </div>

                {/* 폼 입력들 */}
                <div className="mobile-url-create-form">
                    {/* <label className="mobile-url-create-field">
                        <div className="mobile-url-create-field-label">판매상태</div>
                        <div className="mobile-url-create-select-wrap">
                            <select className="mobile-url-create-select" value={form.status} onChange={onChange("status")}>
                                <option value="" disabled>
                                    선택
                                </option>
                                <option value="ON">판매중</option>
                                <option value="OFF">판매중지</option>
                                <option value="HIDE">비공개</option>
                            </select>
                            <span className="mobile-url-create-caret" />
                        </div>
                    </label> */}

                    <label className="mobile-url-create-field">
                        <div className="mobile-url-create-field-label">상품명</div>
                        <input
                            className="mobile-url-create-input"
                            placeholder="상품명을 입력하세요."
                            value={form.name}
                            onChange={onChange("name")}
                        />
                    </label>

                    <div style={{ display: "flex", gap: "10px" }}>
                        <label className="mobile-url-create-field" style={{ flex: 1 }}>
                            <div className="mobile-url-create-field-label">상품가격</div>
                            <input
                                type="number"
                                className="mobile-url-create-input"
                                placeholder="예: 10000"
                                min="0"
                                step="1"
                                value={form.price}
                                onChange={onChange("price")}
                            />
                        </label>
                        <label className="mobile-url-create-field" style={{ flex: 1 }}>
                            <div className="mobile-url-create-field-label">할인가</div>
                            <input
                                type="number"
                                className="mobile-url-create-input"
                                placeholder="예: 8000"
                                min="0"
                                step="1"
                                value={form.discountPrice}
                                onChange={onChange("discountPrice")}
                            />
                        </label>
                    </div>

                    <div style={{ display: "flex", gap: "10px" }}>
                        <label className="mobile-url-create-field" style={{ flex: 1 }}>
                            <div className="mobile-url-create-field-label">배송비</div>
                            <input
                                type="number"
                                className="mobile-url-create-input"
                                placeholder="예: 2500"
                                min="0"
                                step="1"
                                value={form.shippingFee}
                                onChange={onChange("shippingFee")}
                            />
                        </label>
                        <label className="mobile-url-create-field" style={{ flex: 1 }}>
                            <div className="mobile-url-create-field-label">무료배송 최소금액</div>
                            <input
                                type="number"
                                className="mobile-url-create-input"
                                placeholder="예: 50000"
                                min="0"
                                step="1"
                                value={form.freeShippingMin}
                                onChange={onChange("freeShippingMin")}
                            />
                        </label>
                    </div>

                    {/* <div style={{ display: "flex", gap: "10px" }}>
                        <label className="mobile-url-create-field" style={{ flex: 1 }}>
                            <div className="mobile-url-create-field-label">재고 수량</div>
                            <input
                                className="mobile-url-create-input"
                                placeholder="예: 1,000"
                                inputMode="numeric"
                                value={form.stockQty}
                                onChange={onChange("stockQty")}
                            />
                        </label>
                        <label className="mobile-url-create-field" style={{ flex: 1 }}>
                            <div className="mobile-url-create-field-label">구매 최대 가능 수량</div>
                            <input
                                className="mobile-url-create-input"
                                placeholder="예: 10"
                                inputMode="numeric"
                                value={form.maxQty}
                                onChange={onChange("maxQty")}
                            />
                        </label>
                    </div> */}

                    <div>
                        <div className="mobile-url-create-sublabel">상품설명 이미지 (최대 9개)</div>
                        <div className="mobile-url-create-desc-row">
                            <button type="button" className="mobile-url-create-image-picker" onClick={onPickDesc}>
                                <span className="mobile-url-create-plus" />
                                <span>이미지 선택{descImages.length ? ` (${descImages.length}/9)` : ""}</span>
                            </button>
                            <input
                                ref={descFileRef}
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={onDescChange}
                                hidden
                            />
                        </div>

                        {descPreviews.length > 0 && (
                            <div className="mobile-url-create-thumb-grid">
                                {descPreviews.map((src, idx) => (
                                    <div key={idx} className="mobile-url-create-thumb">
                                        <img src={getImageSrc(src)} alt={`설명이미지 ${idx + 1}`} />
                                        <button
                                            type="button"
                                            className="mobile-url-create-thumb-remove"
                                            onClick={() => removeDescAt(idx)}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* ===== 옵션 추가 섹션 ===== */}
                    <div className="mobile-url-create-section" style={{ marginTop: 18 }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: 10,
                            }}
                        >
                            <div style={{ fontSize: 16, fontWeight: 700, letterSpacing: "-.2px" }}>옵션추가</div>
                            <button
                                type="button"
                                onClick={addOption}
                                aria-label="옵션 추가"
                                style={{
                                    padding: "6px 10px",
                                    border: "1px solid #E5E7EB",
                                    background: "#fff",
                                    borderRadius: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 5,
                                    fontSize: 13,
                                    lineHeight: 1,
                                }}
                            >
                                <span
                                    aria-hidden
                                    style={{ width: 16, height: 16, display: "inline-block", position: "relative" }}
                                >
                                    <span
                                        style={{
                                            position: "absolute",
                                            left: 0,
                                            top: "50%",
                                            width: "100%",
                                            height: 2,
                                            marginTop: -1,
                                            background: "#9CA3AF",
                                            borderRadius: 2,
                                        }}
                                    />
                                    <span
                                        style={{
                                            position: "absolute",
                                            left: "50%",
                                            top: 0,
                                            width: 2,
                                            height: "100%",
                                            marginLeft: -1,
                                            background: "#9CA3AF",
                                            borderRadius: 2,
                                        }}
                                    />
                                </span>
                                <span>추가</span>
                            </button>
                        </div>

                        {/* 헤더 */}
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1.7fr 1fr 0.8fr 34px",
                                gap: 5,
                                alignItems: "center",
                                fontSize: 12,
                                opacity: 0.8,
                                marginBottom: 6,
                            }}
                        >
                            <div>옵션명</div>
                            <div>추가금</div>
                            <div>재고</div>
                            <div />
                        </div>

                        {/* 행들 */}
                        <div style={{ display: "grid", gap: 8 }}>
                            {options.map((opt) => (
                                <div
                                    key={opt.id}
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1.7fr 1fr 0.8fr 34px",
                                        gap: 8,
                                        alignItems: "center",
                                    }}
                                >
                                    <input
                                        className="mobile-url-create-input"
                                        value={opt.name}
                                        onChange={updateOption(opt.id, "name")}
                                    />
                                    <input
                                        type="number"
                                        className="mobile-url-create-input"
                                        min="0"
                                        step="1"
                                        value={opt.extraPrice}
                                        onChange={updateOption(opt.id, "extraPrice")}
                                    />
                                    <input
                                        type="number"
                                        className="mobile-url-create-input"
                                        min="0"
                                        step="1"
                                        value={opt.stock}
                                        onChange={updateOption(opt.id, "stock")}
                                    />
                                    {opt.isBase ? (
                                        <div style={{ height: 36 }} />
                                    ) : (
                                        <button
                                            type="button"
                                            onClick={() => removeOption(opt.id)}
                                            aria-label="옵션 삭제"
                                            style={{
                                                width: 34,
                                                height: 34,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                border: "1px solid #E5E7EB",
                                                background: "#fff",
                                                color: "#374151",
                                                fontSize: 18,
                                                lineHeight: 1,
                                                borderRadius: 8,
                                                cursor: "pointer",
                                            }}
                                        >
                                            ×
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* ===== 옵션 추가 섹션 끝 ===== */}
                </div>
            </div>

            <div style={{
                position: "sticky",
                bottom: "0",
                left: "0",
                width: "100%",
                background: "#fff",
                padding: "0 16px 16px"
            }}>
                {/* 구분선 */}
                <div className="mobile-url-create-divider" />

                {/* 버튼 영역 */}
                <div className="mobile-url-create-actions">
                    <button type="button" className="mobile-url-create-btn primary"
                        onClick={onSubmit}
                        disabled={isSubmitting}>
                        등록
                    </button>
                    <button type="button" className="mobile-url-create-btn ghost"
                        onClick={onCancel}>
                        취소
                    </button>
                </div>
            </div>
        </div>
    );
}

function MobileUpdateInfo({ setMessage, setReload, setMobileTab, product, onBack, state }) {
    const MyData = useSelector((state) => state.MyData);
    const [form, setForm] = useState({
        status: product?.product_type === "1" ? "ON" : "OFF",
        name: product?.product_name || "",
        price: product?.price ? String(product.price) : "",
        discountPrice: product?.discount_price ? String(product.discount_price) : "",
        shippingFee: product?.shipping_fee ? String(product.shipping_fee) : "",
        freeShippingMin: product?.free_shipping_min_amount ? String(product.free_shipping_min_amount) : "",
        stockQty: product?.quantity ? String(product.quantity) : "",
        maxQty: product?.max_qty ? String(product.max_qty) : "",
    });

    // ---- 옵션 상태 (기본 1행 유지) ----
    const deriveInitialOptions = (p) => {
        const raw = Array.isArray(p?.options) ? p.options : [];
        if (raw.length === 0) {
            return [{ id: 1, name: "기본", extraPrice: "", stock: "", isBase: true }];
        }
        // API 응답 구조에 맞게 매핑: optionName, additionalPrice, stockQuantity
        const baseMapped = raw.map((o, idx) => ({
            id: o.optionId || Date.now() + idx,
            name: (o.optionName ?? "").toString(),
            extraPrice: o.additionalPrice != null ? String(o.additionalPrice) : "",
            stock: o.stockQuantity != null ? String(o.stockQuantity) : "",
            isBase: idx === 0, // 첫 번째 옵션을 기본으로 설정
        }));
        return baseMapped;
    };

    const [options, setOptions] = useState(deriveInitialOptions(product));

    // 중복 클릭 방지
    const [isSubmitting, setIsSubmitting] = useState(false);

    // 원본 스냅샷(취소 시 복원)
    const originalRef = useRef(form);
    const optionsOriginalRef = useRef(options);

    // 대표 이미지
    const repFileRef = useRef(null);
    const [repImage, setRepImage] = useState(/** @type {File|null} */(null));
    const [repPreview, setRepPreview] = useState(product?.img || null);

    // 설명 이미지(다중)
    const descFileRef = useRef(null);
    const [descImages, setDescImages] = useState(/** @type {File[]} */([]));
    const [descPreviews, setDescPreviews] = useState(/** @type {string[]} */([]));

    // product가 바뀌면 초기화 & 스냅샷 갱신
    useEffect(() => {
        const base = {
            status: product?.product_type === "1" ? "ON" : "OFF",
            name: product?.product_name || "",
            price: product?.price ? String(product.price) : "",
            discountPrice: product?.discount_price ? String(product.discount_price) : "",
            shippingFee: product?.shipping_fee ? String(product.shipping_fee) : "",
            freeShippingMin: product?.free_shipping_min_amount ? String(product.free_shipping_min_amount) : "",
            stockQty: product?.quantity ? String(product.quantity) : "",
            maxQty: product?.max_qty ? String(product.max_qty) : "",
        };
        setForm(base);
        originalRef.current = base;

        const initOpts = deriveInitialOptions(product);
        setOptions(initOpts);
        optionsOriginalRef.current = initOpts;

        setRepPreview(product?.main_image ? getImageSrc(product.main_image) : null);
        setRepImage(null);
        setDescImages([]);
        // descriptionImages 배열에서 imageUrl 추출하여 미리보기 설정
        const descImageUrls = product?.descriptionImages?.map(img => getImageSrc(img.imageUrl)) || [];
        setDescPreviews(descImageUrls);
    }, [product]);

    const goBack = () => (onBack ? onBack() : setMobileTab(0));
    const onChange = (key) => (e) => setForm((p) => ({ ...p, [key]: e.target.value }));

    // URL 복사 함수
    const handleCopy = (product_url) => {
        if (product_url) {
            navigator.clipboard
                .writeText(product_url)
                .then(() => {
                    alert("URL이 복사되었습니다.");
                })
                .catch((err) => {
                    console.error("클립보드 복사 실패:", err);
                });
        }
    };

    // SMS 전송 함수
    const handleSmsSend = async (product_url, smsType, phoneNumber) => {
        try {
            // URL에 type 파라미터 추가
            const urlWithType = smsType === 'KYC' 
                ? `${product_url}${product_url.includes('?') ? '&' : '?'}type=a`
                : `${product_url}${product_url.includes('?') ? '&' : '?'}type=b`;

            // SMS 메시지 내용 생성
            const messageContent = smsType === 'KYC' 
                ? `수기결제 링크: ${urlWithType}` 
                : `인증결제 링크: ${urlWithType}`;

            const response = await axios.post(`${process.env.REACT_APP_API}/api/sms/send`, {
                messageType: "SMS",
                callback: process.env.REACT_APP_SMS_CALLBACK_NUMBER || "0319908587",
                phoneList: [
                    { phone: phoneNumber.replace(/[^0-9]/g, '') } // 숫자만 추출
                ],
                carrierMessage: {
                    message: messageContent
                }
            });
            
            if (response.status === 200) {
                alert("SMS가 전송되었습니다.");
            } else {
                alert("SMS 전송에 실패했습니다.");
            }
        } catch (error) {
            console.error("SMS 전송 오류:", error);
            alert("SMS 전송 중 오류가 발생했습니다.");
        }
    };

    // 핸드폰번호 입력 모달 상태
    const [smsModal, setSmsModal] = useState(false);
    const [smsType, setSmsType] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    // SMS 버튼 클릭 시 모달 열기
    const handleSmsButtonClick = (type) => {
        setSmsType(type);
        setPhoneNumber('');
        setSmsModal(true);
    };

    // SMS 전송 실행
    const handleSmsSubmit = () => {
        if (!phoneNumber.trim()) {
            alert("핸드폰번호를 입력해주세요.");
            return;
        }
        
        // 핸드폰번호 형식 검증 (간단한 검증)
        const phoneRegex = /^[0-9-+\s()]{10,}$/;
        if (!phoneRegex.test(phoneNumber.replace(/\s/g, ''))) {
            alert("올바른 핸드폰번호를 입력해주세요.");
            return;
        }

        handleSmsSend(product?.product_url, smsType, phoneNumber);
        setSmsModal(false);
    };

    // 대표이미지 선택/삭제
    const onPickRep = () => repFileRef.current?.click();
    const onRepChange = (e) => {
        const f = e.target.files?.[0];
        if (!f) return;
        setRepImage(f);
        setRepPreview(URL.createObjectURL(f));
        e.target.value = "";
    };
    const clearRep = () => {
        setRepImage(null);
        setRepPreview(null);
    };

    // 설명이미지 선택/삭제
    const onPickDesc = () => descFileRef.current?.click();
    const onDescChange = (e) => {
        const files = Array.from(e.target.files || []);
        if (!files.length) return;
        const room = Math.max(0, 10 - descImages.length);
        const add = files.slice(0, room);
        setDescImages((prev) => [...prev, ...add]);
        setDescPreviews((prev) => [...prev, ...add.map((f) => URL.createObjectURL(f))]);
        e.target.value = "";
    };
    const removeDescAt = (idx) => {
        setDescImages((prev) => prev.filter((_, i) => i !== idx));
        setDescPreviews((prev) => prev.filter((_, i) => i !== idx));
    };

    // ===== 옵션 조작 =====
    const addOption = () =>
        setOptions((prev) => [
            ...prev,
            { id: Date.now(), name: "", extraPrice: "", stock: "", isBase: false },
        ]);

    const removeOption = (id) =>
        setOptions((prev) => prev.filter((opt) => opt.id !== id));

    const updateOption = (id, key) => (e) =>
        setOptions((prev) =>
            prev.map((opt) => (opt.id === id ? { ...opt, [key]: e.target.value } : opt))
        );

    // 삭제 함수
    const onDelete = async () => {
        if (!product?.product_code) {
            setMessage({ msg: "상품 정보가 없습니다." });
            return;
        }

        if (!window.confirm("정말로 이 상품을 삭제하시겠습니까?")) {
            return;
        }

        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API}/api/url-products/delete/${product.product_code}`,
                {},
                { withCredentials: true }
            );

            const data = response.data;
            if (data.code === 1000) {
                setMessage({ msg: "상품 삭제에 성공했습니다." });
                setReload(prev => !prev);
                if (state === 1) goBack();
            } else {
                setMessage({ msg: data.msg || "상품 삭제에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "상품 삭제에 실패했습니다." });
        } finally {
            setIsSubmitting(false);
        }
    };

    // 저장(API 호출 -> 성공 시 목록으로)
    const onSave = async () => {
        if (!product?.product_code) {
            setMessage({ msg: "상품 정보가 없습니다." });
            return;
        }

        // 중복 클릭 방지
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
        const fd = new FormData();
            
            // 서버 API에 맞는 필드명으로 전송
            fd.append("productName", form.name);
        fd.append("price", form.price);
            fd.append("quantity", form.stockQty !== '' && form.stockQty != null ? form.stockQty : String(product?.quantity ?? ''));
            fd.append("productType", form.status === "ON" ? "1" : "2");
        fd.append("discountPrice", form.discountPrice);
        fd.append("shippingFee", form.shippingFee);
            fd.append("freeShippingMinAmount", form.freeShippingMin);
            fd.append("productDescription", product?.product_description || "");

            // 할인/무료배송 여부 계산
            const isDiscountActive = Number(form.discountPrice) > 0 && Number(form.discountPrice) < Number(form.price);
            const isFreeShipping = Number(form.shippingFee) === 0 || Number(form.freeShippingMin) > 0;
            fd.append("isDiscountActive", isDiscountActive);
            fd.append("isFreeShipping", isFreeShipping);

            // 옵션 JSON 포함 (서버에서 기대하는 구조로 변환)
            const optionsData = options.map(({ id, name, extraPrice, stock, isBase }) => ({
                optionName: name || "",
                additionalPrice: Number(extraPrice) || 0,
                stockQuantity: Number(stock) || 0
            }));
            fd.append("options", JSON.stringify(optionsData));

            // 이미지 파일들
            if (repImage) fd.append("mainImage", repImage, repImage.name);
            descImages.forEach((f) => fd.append("descriptionImages", f, f.name));

            const response = await axios.post(
                `${process.env.REACT_APP_API}/api/url-products/update/${product.product_code}`,
                fd,
                { 
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            const data = response.data;
            if (data.code === 1000) {
                setMessage({ msg: "상품 수정에 성공했습니다." });
                setReload(prev => !prev);
        if (state === 1) goBack();
            } else {
                setMessage({ msg: data.msg || "상품 수정에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "상품 수정에 실패했습니다." });
        } finally {
            setIsSubmitting(false);
        }
    };

    // 취소: 값 & 옵션 복원(화면은 유지)
    const onCancel = () => {
        setForm(originalRef.current);
        setOptions(optionsOriginalRef.current);
        setRepPreview(product?.main_image ? getImageSrc(product.main_image) : null);
        setRepImage(null);
        setDescImages([]);
        setDescPreviews(product?.descriptionImages?.map(img => getImageSrc(img.imageUrl)) || []);
    };

    // 상단 뒤로가기 바
    const TopBar = (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "10px 0px",
                borderBottom: "1px solid #eee",
            }}
        >
            <button
                type="button"
                onClick={goBack}
                aria-label="뒤로가기"
                style={{
                    width: 36,
                    height: 36,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <svg width="22" height="22" viewBox="0 0 24 24">
                    <path
                        d="M15 18L9 12L15 6"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
            <div className="mobile-url-create-title" style={{ margin: 0 }}>
                상품수정
            </div>
            <div style={{ flex: 1 }} />
        </div>
    );

    // 옵션 헤더/행 그리드 스타일
    const optGridStyle = {
        display: "grid",
        gridTemplateColumns: "1.7fr 1fr 1fr 40px",
        gap: 8,
        alignItems: "center",
    };

    return (
        <>
            {state === 1 && TopBar}
            <div className="mobile-url-create-wrap">
                <div style={{ padding: "12px 16px 0px" }}>
                    {/* URL 주소 */}
                    <div style={{ 
                        display: "flex", 
                        gap: "8px", 
                        justifyContent: "center",
                        width: "100%",
                        maxWidth: "100%",
                        overflow: "hidden",
                        flexWrap: "wrap",
                        marginBottom: "24px"
                    }}>
                                <button
                                    onClick={() => handleCopy(product?.product_url)}
                                    style={{ 
                                        fontSize: "14px", 
                                        padding: "12px 20px",
                                        backgroundColor: "#6b7280",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "12px",
                                        cursor: "pointer",
                                        fontWeight: "600",
                                        boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
                                        transition: "all 0.2s ease",
                                        minWidth: "100px",
                                        height: "48px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px",
                                        flex: "1"
                                    }}
                                    onMouseOver={(e) => {
                                        e.target.style.backgroundColor = "#4b5563";
                                        e.target.style.transform = "translateY(-2px)";
                                        e.target.style.boxShadow = "0 6px 12px rgba(0,0,0,0.2)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.backgroundColor = "#6b7280";
                                        e.target.style.transform = "translateY(0)";
                                        e.target.style.boxShadow = "0 3px 6px rgba(0,0,0,0.15)";
                                    }}
                                >
                                    <Copy size={16} />
                                    URL 복사
                                </button>
                                {MyData.smsKYC === 1 && (
                                    <button
                                        onClick={() => handleSmsButtonClick('KYC')}
                                        style={{ 
                                            fontSize: "14px", 
                                            padding: "12px 20px",
                                            backgroundColor: "#3b82f6",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "12px",
                                            cursor: "pointer",
                                            fontWeight: "600",
                                            boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
                                            transition: "all 0.2s ease",
                                            minWidth: "100px",
                                            height: "48px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flex: "1"
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.backgroundColor = "#2563eb";
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 6px 12px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.backgroundColor = "#3b82f6";
                                            e.target.style.transform = "translateY(0)";
                                            e.target.style.boxShadow = "0 3px 6px rgba(0,0,0,0.15)";
                                        }}
                                    >
                                        수기결제
                                    </button>
                                )}
                                {MyData.smsConfirm === 1 && (
                                    <button
                                        onClick={() => handleSmsButtonClick('CONFIRM')}
                                        style={{ 
                                            fontSize: "14px", 
                                            padding: "12px 20px",
                                            backgroundColor: "#10b981",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "12px",
                                            cursor: "pointer",
                                            fontWeight: "600",
                                            boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
                                            transition: "all 0.2s ease",
                                            minWidth: "100px",
                                            height: "48px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flex: "1"
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.backgroundColor = "#059669";
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 6px 12px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.backgroundColor = "#10b981";
                                            e.target.style.transform = "translateY(0)";
                                            e.target.style.boxShadow = "0 3px 6px rgba(0,0,0,0.15)";
                                        }}
                                    >
                                        인증결제
                                    </button>
                                )}
                    </div>

                    {/* 핸드폰번호 입력 모달 */}
                    {smsModal && (
                        <div style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1000
                        }}>
                            <div style={{
                                backgroundColor: "white",
                                borderRadius: "12px",
                                padding: "24px",
                                width: "90%",
                                maxWidth: "400px",
                                boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)"
                            }}>
                                <h3 style={{
                                    margin: "0 0 16px 0",
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    color: "#1f2937"
                                }}>
                                    {smsType === 'KYC' ? '수기결제' : '인증결제'} SMS 전송
                                </h3>
                                <p style={{
                                    margin: "0 0 16px 0",
                                    fontSize: "14px",
                                    color: "#6b7280"
                                }}>
                                    핸드폰번호를 입력해주세요.
                                </p>
                                <input
                                    type="tel"
                                    placeholder="010-1234-5678"
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                    style={{
                                        width: "100%",
                                        padding: "12px 16px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "8px",
                                        fontSize: "16px",
                                        marginBottom: "20px",
                                        boxSizing: "border-box"
                                    }}
                                />
                                <div style={{
                                    display: "flex",
                                    gap: "12px",
                                    justifyContent: "flex-end"
                                }}>
                                    <button
                                        onClick={() => setSmsModal(false)}
                                        style={{
                                            padding: "10px 20px",
                                            border: "1px solid #d1d5db",
                                            borderRadius: "8px",
                                            backgroundColor: "white",
                                            color: "#374151",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: "500"
                                        }}
                                    >
                                        취소
                                    </button>
                                    <button
                                        onClick={handleSmsSubmit}
                                        style={{
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "8px",
                                            backgroundColor: smsType === 'KYC' ? "#3b82f6" : "#10b981",
                                            color: "white",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: "600"
                                        }}
                                    >
                                        전송
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* 대표 이미지 */}
                    <div className="mobile-url-create-section">
                        <div className="mobile-url-create-sublabel">대표이미지 (1개)</div>
                        <div className="mobile-url-create-image-row">
                            <div className="mobile-url-create-image-box mobile-url-create-image-box-rep">
                                {repPreview ? (
                                    <>
                                        <img src={getImageSrc(repPreview)} alt="대표 미리보기" />
                                        <button
                                            type="button"
                                            className="mobile-url-create-thumb-remove"
                                            onClick={clearRep}
                                        >
                                            ×
                                        </button>
                                    </>
                                ) : (
                                    <span />
                                )}
                            </div>
                            <button
                                type="button"
                                className="mobile-url-create-image-picker"
                                onClick={onPickRep}
                            >
                                <span className="mobile-url-create-plus" />
                                <span>이미지 선택</span>
                            </button>
                            <input
                                ref={repFileRef}
                                type="file"
                                accept="image/*"
                                onChange={onRepChange}
                                hidden
                            />
                        </div>
                    </div>

                    {/* 폼 입력 */}
                    <div className="mobile-url-create-form">
                        <label className="mobile-url-create-field">
                            <div className="mobile-url-create-field-label">판매상태</div>
                            <div className="mobile-url-create-select-wrap">
                                <select
                                    className="mobile-url-create-select"
                                    value={form.status}
                                    onChange={onChange("status")}
                                >
                                    <option value="ON">판매중</option>
                                    <option value="OFF">판매중지</option>
                                    <option value="HIDE">비공개</option>
                                </select>
                                <span className="mobile-url-create-caret" />
                            </div>
                        </label>


                        <label className="mobile-url-create-field">
                            <div className="mobile-url-create-field-label">상품명</div>
                            <input
                                className="mobile-url-create-input"
                                placeholder="상품명을 입력하세요."
                                value={form.name}
                                onChange={onChange("name")}
                            />
                        </label>

                        <div style={{ display: "flex", gap: "10px" }}>
                            <label className="mobile-url-create-field" style={{ flex: 1 }}>
                                <div className="mobile-url-create-field-label">상품가격</div>
                                <input
                                    type="number"
                                    className="mobile-url-create-input"
                                    min="0"
                                    step="1"
                                    value={form.price}
                                    onChange={onChange("price")}
                                />
                            </label>
                            <label className="mobile-url-create-field" style={{ flex: 1 }}>
                                <div className="mobile-url-create-field-label">할인가</div>
                                <input
                                    type="number"
                                    className="mobile-url-create-input"
                                    min="0"
                                    step="1"
                                    value={form.discountPrice}
                                    onChange={onChange("discountPrice")}
                                />
                            </label>
                        </div>

                        <div style={{ display: "flex", gap: "10px" }}>
                            <label className="mobile-url-create-field" style={{ flex: 1 }}>
                                <div className="mobile-url-create-field-label">배송비</div>
                                <input
                                    type="number"
                                    className="mobile-url-create-input"
                                    min="0"
                                    step="1"
                                    value={form.shippingFee}
                                    onChange={onChange("shippingFee")}
                                />
                            </label>
                            <label className="mobile-url-create-field" style={{ flex: 1 }}>
                                <div className="mobile-url-create-field-label">무료배송 최소금액</div>
                                <input
                                    type="number"
                                    className="mobile-url-create-input"
                                    min="0"
                                    step="1"
                                    value={form.freeShippingMin}
                                    onChange={onChange("freeShippingMin")}
                                />
                            </label>
                        </div>

                        {/* <div style={{ display: "flex", gap: "10px" }}>
                            <label className="mobile-url-create-field" style={{ flex: 1 }}>
                                <div className="mobile-url-create-field-label">재고 수량</div>
                                <input
                                    className="mobile-url-create-input"
                                    inputMode="numeric"
                                    value={form.stockQty}
                                    onChange={onChange("stockQty")}
                                />
                            </label>
                            <label className="mobile-url-create-field" style={{ flex: 1 }}>
                                <div className="mobile-url-create-field-label">구매 최대 가능 수량</div>
                                <input
                                    className="mobile-url-create-input"
                                    inputMode="numeric"
                                    value={form.maxQty}
                                    onChange={onChange("maxQty")}
                                />
                            </label>
                        </div> */}

                        {/* 설명 이미지 */}
                        <div>
                            <div className="mobile-url-create-sublabel">상품설명 이미지 (최대 10개)</div>
                            <div className="mobile-url-create-desc-row">
                                <button
                                    type="button"
                                    className="mobile-url-create-image-picker"
                                    onClick={onPickDesc}
                                >
                                    <span className="mobile-url-create-plus" />
                                    <span>
                                        이미지 선택
                                        {descImages.length ? ` (${descImages.length}/10)` : ""}
                                    </span>
                                </button>
                                <input
                                    ref={descFileRef}
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={onDescChange}
                                    hidden
                                />
                            </div>

                            {descPreviews.length > 0 && (
                                <div className="mobile-url-create-thumb-grid">
                                    {descPreviews.map((src, idx) => (
                                        <div key={idx} className="mobile-url-create-thumb">
                                            <img src={getImageSrc(src)} alt={`설명이미지 ${idx + 1}`} />
                                            <button
                                                type="button"
                                                className="mobile-url-create-thumb-remove"
                                                onClick={() => removeDescAt(idx)}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* ===== 옵션 추가 섹션 ===== */}
                        <div className="mobile-url-create-section" style={{ marginTop: 18 }}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    marginBottom: 10,
                                }}
                            >
                                {/* 제목 크게/굵게 */}
                                <div style={{ fontSize: 16, fontWeight: 700, letterSpacing: "-0.2px" }}>
                                    옵션추가
                                </div>

                                {/* 추가 버튼 작게 */}
                                <button
                                    type="button"
                                    onClick={addOption}
                                    aria-label="옵션 추가"
                                    style={{
                                        padding: "6px 10px",
                                        border: "1px solid #E5E7EB",
                                        background: "#fff",
                                        borderRadius: 10,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 6,
                                        fontSize: 13,
                                        lineHeight: 1,
                                    }}
                                >
                                    <span
                                        aria-hidden
                                        style={{
                                            width: 16,
                                            height: 16,
                                            display: "inline-block",
                                            position: "relative",
                                        }}
                                    >
                                        <span
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                top: "50%",
                                                width: "100%",
                                                height: 2,
                                                marginTop: -1,
                                                background: "#9CA3AF",
                                                borderRadius: 2,
                                            }}
                                        />
                                        <span
                                            style={{
                                                position: "absolute",
                                                left: "50%",
                                                top: 0,
                                                width: 2,
                                                height: "100%",
                                                marginLeft: -1,
                                                background: "#9CA3AF",
                                                borderRadius: 2,
                                            }}
                                        />
                                    </span>
                                    <span>추가</span>
                                </button>
                            </div>

                            {/* 헤더 */}
                            <div
                                style={{
                                    ...optGridStyle,
                                    fontSize: 12,
                                    opacity: 0.8,
                                    marginBottom: 6,
                                }}
                            >
                                <div>옵션명</div>
                                <div>추가금</div>
                                <div>재고</div>
                                <div></div>
                            </div>

                            {/* 행들 */}
                            <div style={{ display: "grid", gap: 8 }}>
                                {options.map((opt) => (
                                    <div key={opt.id} style={optGridStyle}>
                                        <input
                                            className="mobile-url-create-input"
                                            placeholder="예: 기본 / 레드 / 대형"
                                            value={opt.name}
                                            onChange={updateOption(opt.id, "name")}
                                        />
                                        <input
                                            type="number"
                                            className="mobile-url-create-input"
                                            placeholder="예: 0"
                                            min="0"
                                            step="1"
                                            value={opt.extraPrice}
                                            onChange={updateOption(opt.id, "extraPrice")}
                                        />
                                        <input
                                            type="number"
                                            className="mobile-url-create-input"
                                            placeholder="예: 100"
                                            min="0"
                                            step="1"
                                            value={opt.stock}
                                            onChange={updateOption(opt.id, "stock")}
                                        />
                                        {opt.isBase ? (
                                            <div style={{ height: 36 }} />
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={() => removeOption(opt.id)}
                                                aria-label="옵션 삭제"
                                                style={{
                                                    width: 36,
                                                    height: 36,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    border: "1px solid #E5E7EB",
                                                    background: "#fff",
                                                    color: "#374151",
                                                    fontSize: 18,
                                                    lineHeight: 1,
                                                    borderRadius: 8,
                                                    cursor: "pointer",
                                                }}
                                            >
                                                ×
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                        {/* ===== 옵션 추가 섹션 끝 ===== */}
                    </div>
                </div>

                <div style={{
                    position: "sticky",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    background: "#fff",
                    padding: "0 16px 16px"
                }}>
                    {/* 구분선 */}
                    <div className="mobile-url-create-divider" />

                    {/* 버튼 영역 */}
                    <div className="mobile-url-create-actions">
                        <button type="button" className="mobile-url-create-btn ghost" onClick={onCancel}>
                            초기화
                        </button>
                        <button 
                            type="button" 
                            className="mobile-url-create-btn primary" 
                            onClick={onSave}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "수정 중..." : "수정"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

function CreateInfo({ setMessage, setReload }) {
    // 초기값(모두 빈 문자열)
    const initialFormData = {
        상품명: '',
        결제금액: '',
        수량: '',
        상태: '1',
    };

    // 상태
    const [formData, setFormData] = useState(initialFormData);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // 중복 클릭 방지
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            await axios.post(process.env.REACT_APP_API + "/api/url-products", {
                productName: formData.상품명,
                price: formData.결제금액,
                quantity: formData.수량,
                productType: formData.상태,
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data;
                if (tmp?.code < 2000) {
                    setMessage({ msg: "상품 등록에 성공했습니다." });
                    setReload(e => !e);
                    // 등록에 성공했다면 폼을 다시 초기화
                    setFormData(initialFormData);
                } else {
                    setMessage({ msg: tmp?.msg ?? "상품 등록에 실패했습니다." });
                }
            }).catch(error => {
                setMessage({ msg: "상품 등록에 실패했습니다." });
                console.error(error);
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    // [추가] 취소 버튼 핸들러
    const handleCancel = () => {
        setFormData(initialFormData);
    };

    return (
        <div style={{ padding: "5px" }}>
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty">
                    <div
                        style={{
                            padding: '0 0 0.5rem',
                            height: "300px",
                            overflowY: "auto",
                            fontSize: "12px",
                            display: 'flex',
                            flexDirection: "column",
                        }}
                    >
                        <div className="list-info-box">
                            <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                <ul>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>상품명</span>
                                            <input
                                                id="상품명"
                                                name="상품명"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.상품명}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>결제금액</span>
                                            <input
                                                id="결제금액"
                                                name="결제금액"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.결제금액}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>수량</span>
                                            <input
                                                id="수량"
                                                name="수량"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.수량}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>상태</span>
                                            <select
                                                id="상태"
                                                name="상태"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.상태}
                                                onChange={handleChange}
                                            >
                                                <option value="1">활성</option>
                                                <option value="2">비활성</option>
                                            </select>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="modal-footer" style={{ paddingRight: "0" }}>
                            <button
                                type="button"
                                className="btn btn-primary w-20 reg_btn"
                                onClick={onSubmit}
                                disabled={isSubmitting}
                            >
                                등록
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary w-20 close_btn"
                                onClick={handleCancel}
                                style={{
                                    backgroundColor: "darkred",
                                    marginLeft: "10px",
                                    border: "none"
                                }}
                            >
                                취소
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function UpdateInfo({ setMessage, clickData, setReload }) {
    const MyData = useSelector((state) => state.MyData);

    const initialFormData = {
        상품코드: clickData?.product_code ?? '',
        상품명: clickData?.product_name ?? '',
        결제금액: clickData?.price ?? '',
        수량: clickData?.quantity ?? '',
        상태: clickData?.product_type ?? '1',
        URL: clickData?.product_url ?? '',
    };

    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        if (clickData) {
            setFormData({
                상품코드: clickData?.product_code ?? '',
                상품명: clickData?.product_name ?? '',
                결제금액: clickData?.price ?? '',
                수량: clickData?.quantity ?? '',
                상태: clickData?.product_type ?? '1',
                URL: clickData?.product_url ?? '',
            });
        }
    }, [clickData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // ▼ 중복 클릭 방지용 상태
    const [isSubmitting, setIsSubmitting] = useState(false);

    // 핸드폰번호 입력 모달 상태
    const [smsModal, setSmsModal] = useState(false);
    const [smsType, setSmsType] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    // SMS 버튼 클릭 시 모달 열기
    const handleSmsButtonClick = (type) => {
        setSmsType(type);
        setPhoneNumber('');
        setSmsModal(true);
    };

    // SMS 전송 실행
    const handleSmsSubmit = () => {
        if (!phoneNumber.trim()) {
            alert("핸드폰번호를 입력해주세요.");
            return;
        }
        
        // 핸드폰번호 형식 검증 (간단한 검증)
        const phoneRegex = /^[0-9-+\s()]{10,}$/;
        if (!phoneRegex.test(phoneNumber.replace(/\s/g, ''))) {
            alert("올바른 핸드폰번호를 입력해주세요.");
            return;
        }

        handleSmsSend(formData.URL, smsType, phoneNumber);
        setSmsModal(false);
    };

    const onSubmit = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        if (window.confirm("수정하시겠습니까?")) {
            try {
                const fd = new FormData();
                
                // 서버 API에 맞는 필드명으로 전송
                fd.append("productName", formData.상품명);
                fd.append("price", formData.결제금액);
                fd.append("quantity", formData.수량 !== '' && formData.수량 != null ? formData.수량 : String(clickData?.quantity ?? ''));
                fd.append("productType", formData.상태);
                fd.append("discountPrice", "");
                fd.append("shippingFee", "0");
                fd.append("freeShippingMinAmount", "0");
                fd.append("productDescription", "");
                fd.append("isDiscountActive", "false");
                fd.append("isFreeShipping", "false");
                fd.append("options", JSON.stringify([]));

                const response = await axios.post(
                    `${process.env.REACT_APP_API}/api/url-products/update/${clickData.product_code}`,
                    fd,
                    { 
                    withCredentials: true,
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                const data = response.data;
                if (data.code === 1000) {
                        setMessage({ msg: "상품 수정에 성공했습니다." });
                    setReload(prev => !prev);
                    } else {
                    setMessage({ msg: data.msg || "상품 수정에 실패했습니다." });
                    }
            } catch (error) {
                    console.error(error);
                setMessage({ msg: "상품 수정에 실패했습니다." });
            } finally {
                setIsSubmitting(false);
            }
        } else {
            setIsSubmitting(false);
        }
    };

    // ▼ 삭제 함수
    const onDelete = async () => {
        if (!clickData?.product_code) {
            setMessage({ msg: "상품 정보가 없습니다." });
            return;
        }

        if (!window.confirm("정말로 이 상품을 삭제하시겠습니까?")) {
            return;
        }

        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API}/api/url-products/delete/${clickData.product_code}`,
                {},
                { withCredentials: true }
            );

            const data = response.data;
            if (data.code === 1000) {
                setMessage({ msg: "상품 삭제에 성공했습니다." });
                setReload(prev => !prev);
            } else {
                setMessage({ msg: data.msg || "상품 삭제에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "상품 삭제에 실패했습니다." });
        } finally {
            setIsSubmitting(false);
        }
    };

    // ▼ 취소 버튼 클릭 시 원래 데이터로 롤백
    const handleCancel = () => {
        setFormData(initialFormData);
    };

    // URL 복사 함수
    const handleCopy = (product_url) => {
        if (product_url) {
            navigator.clipboard
                .writeText(product_url)
                .then(() => {
                    alert("URL이 복사되었습니다.");
                })
                .catch((err) => {
                    console.error("클립보드 복사 실패:", err);
                });
        }
    };

    // SMS 전송 함수
    const handleSmsSend = async (product_url, smsType, phoneNumber) => {
        try {
            // URL에 type 파라미터 추가
            const urlWithType = smsType === 'KYC' 
                ? `${product_url}${product_url.includes('?') ? '&' : '?'}type=a`
                : `${product_url}${product_url.includes('?') ? '&' : '?'}type=b`;

            // SMS 메시지 내용 생성
            const messageContent = smsType === 'KYC' 
                ? `수기결제 링크: ${urlWithType}` 
                : `인증결제 링크: ${urlWithType}`;

            const response = await axios.post(`${process.env.REACT_APP_API}/api/sms/send`, {
                messageType: "SMS",
                callback: process.env.REACT_APP_SMS_CALLBACK_NUMBER || "0319908587",
                phoneList: [
                    { phone: phoneNumber.replace(/[^0-9]/g, '') } // 숫자만 추출
                ],
                carrierMessage: {
                    message: messageContent
                }
            });
            
            if (response.status === 200) {
                alert("SMS가 전송되었습니다.");
            } else {
                alert("SMS 전송에 실패했습니다.");
            }
        } catch (error) {
            console.error("SMS 전송 오류:", error);
            alert("SMS 전송 중 오류가 발생했습니다.");
        }
    };

    const isDisabled = MyData?.role !== "SUPER";

    return (
        <div style={{ padding: "5px" }}>
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty">
                    <div
                        style={{
                            padding: '0 0 0.5rem',
                            height: "300px",
                            overflowY: "auto",
                            fontSize: "12px",
                            display: 'flex',
                            flexDirection: "column",
                        }}
                    >
                        <div className="list-info-box">
                            <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                <ul>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>상품코드</span>
                                            <input
                                                id="상품코드"
                                                name="상품코드"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.상품코드}
                                                onChange={handleChange}
                                                disabled
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>상품명</span>
                                            <input
                                                id="상품명"
                                                name="상품명"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.상품명}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>결제금액</span>
                                            <input
                                                id="결제금액"
                                                name="결제금액"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.결제금액}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>수량</span>
                                            <input
                                                id="수량"
                                                name="수량"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.수량}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>URL</span>
                                            <div style={{ 
                                                display: "flex", 
                                                flexDirection: "column",
                                                gap: "8px",
                                                width: "calc(100% - 122px)"
                                            }}>
                                                <div style={{ 
                                                    display: "flex", 
                                                    alignItems: "center", 
                                                    gap: "8px",
                                                    padding: "6px 8px",
                                                    border: "1px solid #d1d5db",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#f9fafb",
                                                    cursor: "pointer",
                                                    maxWidth: "100%",
                                                    minWidth: 0
                                                }} onClick={() => handleCopy(formData.URL)}>
                                                    <div style={{ 
                                                        flex: 1, 
                                                        overflow: "hidden", 
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        fontSize: "12px",
                                                        color: "#374151",
                                                        maxWidth: "calc(100% - 50px)",
                                                        minWidth: 0
                                                    }}>
                                                        {formData.URL || "URL이 없습니다"}
                                                    </div>
                                                    <div style={{ 
                                                        display: "flex", 
                                                        alignItems: "center", 
                                                        gap: "4px",
                                                        fontSize: "10px",
                                                        color: "#6b7280",
                                                        flexShrink: 0
                                                    }}>
                                                        <Copy size={14} />
                                                        <span>복사</span>
                                                    </div>
                                                </div>
                                                <div style={{ 
                                                    display: "flex", 
                                                    gap: "8px", 
                                                    justifyContent: "center"
                                                }}>
                                                    {MyData.smsKYC === 1 && (
                                                        <button
                                                            onClick={() => handleSmsButtonClick('KYC')}
                                                            style={{ 
                                                                fontSize: "10px", 
                                                                padding: "4px 8px",
                                                                backgroundColor: "#3b82f6",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "6px",
                                                                cursor: "pointer",
                                                                fontWeight: "500",
                                                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                                transition: "all 0.2s ease",
                                                                minWidth: "60px"
                                                            }}
                                                            onMouseOver={(e) => {
                                                                e.target.style.backgroundColor = "#2563eb";
                                                                e.target.style.transform = "translateY(-1px)";
                                                                e.target.style.boxShadow = "0 2px 6px rgba(0,0,0,0.15)";
                                                            }}
                                                            onMouseOut={(e) => {
                                                                e.target.style.backgroundColor = "#3b82f6";
                                                                e.target.style.transform = "translateY(0)";
                                                                e.target.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
                                                            }}
                                                        >
                                                            수기결제
                                                        </button>
                                                    )}
                                                    {MyData.smsConfirm === 1 && (
                                                        <button
                                                            onClick={() => handleSmsButtonClick('CONFIRM')}
                                                            style={{ 
                                                                fontSize: "10px", 
                                                                padding: "4px 8px",
                                                                backgroundColor: "#10b981",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "6px",
                                                                cursor: "pointer",
                                                                fontWeight: "500",
                                                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                                transition: "all 0.2s ease",
                                                                minWidth: "60px"
                                                            }}
                                                            onMouseOver={(e) => {
                                                                e.target.style.backgroundColor = "#059669";
                                                                e.target.style.transform = "translateY(-1px)";
                                                                e.target.style.boxShadow = "0 2px 6px rgba(0,0,0,0.15)";
                                                            }}
                                                            onMouseOut={(e) => {
                                                                e.target.style.backgroundColor = "#10b981";
                                                                e.target.style.transform = "translateY(0)";
                                                                e.target.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
                                                            }}
                                                        >
                                                            인증결제
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="inner" style={{ width: "100%" }}>
                                            <span className="left-text" style={{ width: "120px", height: "34px" }}>상태</span>
                                            <select
                                                id="상태"
                                                name="상태"
                                                type="text"
                                                className="right-text"
                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                maxLength="30"
                                                value={formData.상태}
                                                onChange={handleChange}
                                            >
                                                <option value="1">활성</option>
                                                <option value="2">비활성</option>
                                            </select>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="modal-footer" style={{ paddingRight: "0" }}>
                            <button
                                type="button"
                                className="btn btn-primary w-20 close_btn"
                                onClick={handleCancel}
                                style={{ backgroundColor: "gray", marginRight: "10px", border: "none" }}
                            >
                                초기화
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary w-20 reg_btn"
                                onClick={onSubmit}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "수정 중..." : "수정"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* 핸드폰번호 입력 모달 */}
            {smsModal && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: "white",
                        borderRadius: "12px",
                        padding: "24px",
                        width: "90%",
                        maxWidth: "400px",
                        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)"
                    }}>
                        <h3 style={{
                            margin: "0 0 16px 0",
                            fontSize: "18px",
                            fontWeight: "600",
                            color: "#1f2937"
                        }}>
                            {smsType === 'KYC' ? '수기결제' : '인증결제'} SMS 전송
                        </h3>
                        <p style={{
                            margin: "0 0 16px 0",
                            fontSize: "14px",
                            color: "#6b7280"
                        }}>
                            핸드폰번호를 입력해주세요.
                        </p>
                        <input
                            type="tel"
                            placeholder="010-1234-5678"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "12px 16px",
                                border: "1px solid #d1d5db",
                                borderRadius: "8px",
                                fontSize: "16px",
                                marginBottom: "20px",
                                boxSizing: "border-box"
                            }}
                        />
                        <div style={{
                            display: "flex",
                            gap: "12px",
                            justifyContent: "flex-end"
                        }}>
                            <button
                                onClick={() => setSmsModal(false)}
                                style={{
                                    padding: "10px 20px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "8px",
                                    backgroundColor: "white",
                                    color: "#374151",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    fontWeight: "500"
                                }}
                            >
                                취소
                            </button>
                            <button
                                onClick={handleSmsSubmit}
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "8px",
                                    backgroundColor: smsType === 'KYC' ? "#3b82f6" : "#10b981",
                                    color: "white",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    fontWeight: "600"
                                }}
                            >
                                전송
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `거래내역`;

    const ws = XLSX.utils.aoa_to_sheet([
        [
            "NO", "MID", "거래일시", "취소일시", "거래상태", "거래금액", "결제서비스", "결제구분", "구매자명", "카드", "할부", "상품명", "주문번호", "거래번호"
        ]
    ]);
    excelData.map((data) => {
        XLSX.utils.sheet_add_aoa(
            ws,
            [
                [
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.NO },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.MID },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.취소일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래상태 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래금액 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.결제서비스 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.결제구분 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.구매자명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.카드 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.할부 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.상품명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.주문번호 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래번호 }
                ]
            ],
            { origin: -1 }
        );
        ws['!cols'] = [
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 }
        ]
        return false;
    });
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelButter = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelButter], { type: excelFileType });
    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default UrlCreate;
